"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitchWidget = void 0;
var tslib_1 = require("tslib");
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
exports.ToggleSwitchWidget = React.forwardRef(function (_a, ref) {
    var testId = _a.testId, props = tslib_1.__rest(_a, ["testId"]);
    return React.createElement(tableau_ui_1.ToggleSwitch, tslib_1.__assign({}, props, ReactHelpers_1.EventUtilsOptOut, { "data-tb-test-id": Declarative_1.makeTestId(testId, 'ToggleSwitch'), ref: ref }));
});
exports.ToggleSwitchWidget.displayName = 'ToggleSwitchWidget';
exports.ToggleSwitchWidget.defaultProps = { textAlign: 'left' };
//# sourceMappingURL=ToggleSwitchWidget.js.map